document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('product-form[data-image-target]').forEach(function (formEl) {
    var imageTargetId = formEl.dataset.imageTarget;
    var jsonEl = formEl.querySelector('.variant-images-json');
    if (!imageTargetId || !jsonEl) return;

    var imageTarget = document.getElementById(imageTargetId);
    if (!imageTarget) return;

    var data = JSON.parse(jsonEl.textContent);
    var optionNames = data.option_names;
    var variants = data.variants;
    var originalImageSrc = imageTarget.src;

    // Price elements within this form
    var priceEl = formEl.querySelector('.product__price');
    var comparePriceEl = formEl.querySelector('.product__price-strikethrough');
    var originalPrice = priceEl ? priceEl.textContent : null;
    var originalComparePrice = comparePriceEl ? comparePriceEl.textContent : null;

    function getSelectedOptionMap(hoveredRadio) {
      var selected = {};
      formEl.querySelectorAll('.variant-inputs input[type="radio"], .formato-buttons input[type="radio"], .tipo-de-riscas-buttons input[type="radio"]').forEach(function (radio) {
        if (radio.checked) {
          selected[radio.name] = radio.value;
        }
      });
      if (hoveredRadio) {
        selected[hoveredRadio.name] = hoveredRadio.value;
      }
      return selected;
    }

    function findMatchingVariant(hoveredRadio) {
      var selected = getSelectedOptionMap(hoveredRadio);
      return variants.find(function (v) {
        return optionNames.every(function (name, i) {
          var inputName = 'option' + (i + 1);
          return !selected[inputName] || selected[inputName] === v.options[i];
        });
      });
    }

    function updateTargetImage(match) {
      if (match && match.image) {
        imageTarget.src = match.image;
      } else {
        imageTarget.src = originalImageSrc;
      }
    }

    function updatePrice(match) {
      if (!priceEl) return;
      if (match && match.price) {
        priceEl.textContent = match.price;
        if (comparePriceEl) {
          if (match.compare_at_price) {
            comparePriceEl.textContent = match.compare_at_price;
            comparePriceEl.style.display = '';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }
      } else {
        priceEl.textContent = originalPrice;
        if (comparePriceEl) {
          if (originalComparePrice) {
            comparePriceEl.textContent = originalComparePrice;
            comparePriceEl.style.display = '';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }
      }
    }

    function updateVariantDisplay(hoveredRadio) {
      var match = findMatchingVariant(hoveredRadio);
      updateTargetImage(match);
      updatePrice(match);
    }

    // Set initial price based on actually selected radio buttons
    var initialMatch = findMatchingVariant();
    if (initialMatch && initialMatch.price) {
      originalPrice = initialMatch.price;
      originalComparePrice = initialMatch.compare_at_price || null;
      updatePrice(initialMatch);
    }

    var radios = formEl.querySelectorAll('.variant-inputs input[type="radio"], .formato-buttons input[type="radio"], .tipo-de-riscas-buttons input[type="radio"]');
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        // On selection change, update the "original" so mouseleave reverts to the new selection
        var match = findMatchingVariant();
        if (match) {
          if (match.image) originalImageSrc = match.image;
          originalPrice = match.price;
          originalComparePrice = match.compare_at_price || null;
        }
        updateTargetImage(match);
        updatePrice(match);
      });

      var hoverTarget = radio.closest('.variant-input') || radio.closest('.formato-option-button') || radio.closest('.tipo-de-riscas-option-button');
      if (hoverTarget) {
        hoverTarget.addEventListener('mouseenter', function () {
          updateVariantDisplay(radio);
        });
        hoverTarget.addEventListener('mouseleave', function () {
          updateVariantDisplay();
        });
      }
    });
  });
});
